<template>
    <div>
        <InfoPageBlock
            h1="Trademark went abandoned? Let us revive it for you."
            stepsLength="6"
            url="/trademark-revival/confirm"
        ></InfoPageBlock>
    </div>
</template>

<script>
import InfoPageBlock from '@/components/blocks/InfoPageBlock.vue'
import {to_top} from "@/helper";

export default {
    components: {
        InfoPageBlock
    },
    mounted() {
        this.$store.commit('header/setTotal', 0)
        to_top()
    }
}
</script>
